import React from "react";
import ReactDOM from "react-dom";
import "./app.css";
import App from "./app";
import init from "./infrastructure";

const getJson = (f) => {
  return fetch(f).then((x) => x.json());
};

const merge = (o, rest) => {
  var next = rest.pop();
  if (!next) return o;

  const merged = {
    ...o,
    ...next,
  };

  return merge(merged, rest);
};

const configUri = process.env.PUBLIC_URL + "/config.json";
const styleUri = "/ee-static/booking/style.json";
const files = [configUri, styleUri].map((f) => getJson(f));

Promise.all(files)
  .then((response) => merge({}, response))
  .then((cfg) => {
    console.log("Merged config", cfg);
    fetch(`${cfg.api}/version`)
      .then((response) => response.json())
      .then((v) => {
        const root = document.getElementById("root");
        const required = parseInt(cfg.requiredApiVersion.replace(/\./g, ""));

        console.log("version", v);
        console.log("required", required);

        if (v.version < required) {
          ReactDOM.render(
            <h1>
              Api version {cfg.requiredApiVersion} is required, but was{" "}
              {v.description}
            </h1>,
            root
          );
        } else {
          const intitialized = init(cfg);
          ReactDOM.render(<App config={intitialized} />, root);
        }
      });
  });
